module.exports = __webpack_public_path__ + "static/buy__icon-df668098e84c1615f9776e5f075e2837.svg";